module.exports = __webpack_public_path__ + "static/media/ehr-icon.281f9aca.png";